/**
 * 渠道结算价测算（端内"预计结算价"展示用）
 *
 * 公式：结算价 = 售价 - 命中档位的服务费 - 扣减红包 - 临时红包
 * 档位：取「起算价 <= 售价」的档位中起算价最大的那一档（对应配置里的"售出价大于等于"）
 * 分组：品牌名含「苹果」或以 apple 开头走苹果结算组，其余（含品牌为空）走安卓结算组
 * 测算只服务于展示，提交链路不校验、不落库，实际金额以渠道结算账单为准
 */

/**拉取商户启用渠道的结算公式，回调出 { [channel_id]: {android: [], apple: []} }；未配置公式的渠道服务端不下发*/
export function fetchSettleConfig(vm, callback) {
	vm.request({
		url: '/sale/product/settlement/config',
		success: data => {
			var map = {};
			(data || []).forEach(item => {
				map[item.channel_id] = item;
			});
			if (callback) callback(map);
		}
	});
}

/**品牌是否落在苹果结算组（品牌名由平台统一维护）*/
export function isAppleBrand(brand_name) {
	var name = (brand_name || '').trim().toLowerCase();
	if (!name) return false;
	return name.indexOf('苹果') >= 0 || name.indexOf('apple') === 0;
}

/**取命中的结算档位，售价低于最低档起算价时返回 null（无适用档位）*/
export function matchSettleTier(tiers, sale_price) {
	if (!tiers || !tiers.length) return null;
	var price = parseFloat(sale_price);
	if (!(price > 0)) return null;
	var matched = null;
	for (var i = 0; i < tiers.length; i++) {
		var start = parseFloat(tiers[i].price);
		if (isNaN(start) || start > price) continue;
		if (!matched || start > parseFloat(matched.price)) matched = tiers[i];
	}
	return matched;
}

/**
 * 测算预计结算价
 * @param config_map 结算公式集合（fetchSettleConfig 回调所得）
 * @param channel_id 渠道ID
 * @param brand_name 品牌名称
 * @param sale_price 售价
 * @returns {Number|null} 渠道无公式、未命中档位或售价非法时返回 null，端内不给出金额（不可回落成售价，否则会被当成不收服务费）
 */
export function calcSettlePrice(config_map, channel_id, brand_name, sale_price) {
	var config = config_map ? config_map[channel_id] : null;
	if (!config) return null;
	var tier = matchSettleTier(isAppleBrand(brand_name) ? config.apple : config.android, sale_price);
	if (!tier) return null;
	//换算成分做整数减法，避免浮点误差带出 0.009999
	var settle = toCents(sale_price) - toCents(tier.rate) - toCents(tier.red_packet) - toCents(tier.temp_red_packet);
	return settle / 100;
}

/**金额转分（缺项按0处理，与结算公式里红包留空的语义一致）*/
function toCents(value) {
	var num = parseFloat(value);
	return isNaN(num) ? 0 : Math.round(num * 100);
}
